"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconCredit = void 0;

var React = __importStar(require("react"));

exports.IconCredit = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return React.createElement("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 86.02499999999999",
    x: "0px",
    y: "0px"
  }, props), {}, {
    ref: forwardedRef
  }), React.createElement("title", null, "credit card10"), React.createElement("g", {
    "data-name": "Layer 2"
  }, React.createElement("path", {
    d: "M85.71,13.59H10.29A7.29,7.29,0,0,0,3,20.88V75.12a7.29,7.29,0,0,0,7.29,7.29H85.71A7.29,7.29,0,0,0,93,75.12V20.88A7.29,7.29,0,0,0,85.71,13.59ZM10.29,18.1H85.71a2.79,2.79,0,0,1,2.78,2.78v7.43h-81V20.88A2.79,2.79,0,0,1,10.29,18.1ZM85.71,77.9H10.29a2.79,2.79,0,0,1-2.78-2.78V42h81V75.12A2.79,2.79,0,0,1,85.71,77.9ZM49,53.13H15.88a2,2,0,0,1,0-4H49a2,2,0,0,1,0,4Zm-16.56,9H15.88a2,2,0,0,1,0-4H32.44a2,2,0,0,1,0,4Z",
    transform: "translate(-3 -13.59)"
  })));
});